"use client";

import { createContext, useCallback, useContext } from "react";
import { useRouter } from "next/navigation";

export type PageTransitionNavigate = (href: string) => void;

export const PageTransitionContext = createContext<PageTransitionNavigate | null>(
  null,
);

/** Navigate with the site split transition when available. */
export function usePageTransition(): PageTransitionNavigate {
  const navigate = useContext(PageTransitionContext);
  const router = useRouter();
  return useCallback(
    (href: string) => {
      if (navigate) navigate(href);
      else router.push(href);
    },
    [navigate, router],
  );
}
